import {h, Component} from 'preact';
import events from 'actions/events'
import { LoadingActions } from 'actions';

export default class WidgetComponent extends Component {
	constructor(props){
		super(props)
	}

	componentWillMount(){
		events.trigger(`${this.constructor.name}.componentWillMount`, this)
	}

	componentDidMount(){
		events.trigger(`${this.constructor.name}.componentDidMount`, this)
	}

	componentDidSubmit(){
		events.trigger(`${this.constructor.name}.componentDidSubmit`, this)
		LoadingActions.append({[`${this.constructor.name}`]: false})
	}

	componentWillSubmit(data){
		return new Promise((resolve, reject)=>{
			events.trigger(`${this.constructor.name}.componentWillSubmit`, this)
			LoadingActions.append({[`${this.constructor.name}`]: true})
			return resolve()
		})
	}

	componentFailedToSubmit(){
		events.trigger(`${this.constructor.name}.componentFailedToSubmit`, this)
		LoadingActions.append({[`${this.constructor.name}`]: false})
	}

	componentIsLoading(){
		return this.props.loading[this.constructor.name]
	}

	render(){
		return (
			<span>
			</span>
		);
	}
}



// WEBPACK FOOTER //
// ./components/WidgetComponent.js